import { HEATMAP_BLUE_COLOR_STOPS } from './colors.constants';

export const getUtilizationHeatmapColor = percent => {
  const p = Math.max(0, Math.min(100, percent));
  const nearestStop = Math.round(p / 5) * 5;
  return HEATMAP_BLUE_COLOR_STOPS[nearestStop];
};
